import React from 'react';
import PropTypes from 'prop-types';

class RadioGroup extends React.Component {

    static propTypes = {
        title: PropTypes.any,
        name: PropTypes.string,
        options: PropTypes.array,
        display: PropTypes.string,
        onSelect: PropTypes.func,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        display: 'horizontal',
        options: []
    };

    constructor(props){
        super(props);

        const dIndex = props.options.findIndex(x => x.default == true);

        this.state = {
            selectedIndex: dIndex >= 0 ? dIndex : null
        };

        this._inputs = {};
    }

    getSelected(){
        const index = this.getSelectedIndex();
        if(index != null){
            return this.props.options[index];
        }
    }

    getSelectedIndex(){
        return this.state.selectedIndex;
    }

    selectOption(name){

        var ref = this._inputs[name];
        if(ref){
            ref.checked = true;
        }

    }

    clearSelection(){

        var selection = this.getSelectedIndex();
        if(selection){
            var option = this.props.options[selection];
            if(option){
                this._inputs[option.name].checked = false;
            }
        }

    }

    setSelectedValue(value){

        const optionIndex = this.props.options.findIndex(x => x.value == value);
        if(optionIndex >= 0){
            this.setSelectedIndex(optionIndex);
        }

    }

    setSelectedIndex(index){

        var option = this.props.options[index];
        if(option){
            this.selectOption(option.name);
        }

    }

    onChange(item,i,evt){

        const props = this.props;

        this.setState({
            selectedIndex: i
        });

        if(props.onSelect)
            props.onSelect(item,i);
    }

    render(){

        const props = this.props;
        const options  = props.options;
        const me = this;

        let content;
        switch (props.display){
            case 'horizontal':
                content = <div>
                    {options.map((item,i) => {

                        return <label key={i}  className="form-check-inline">
                            <input type="radio" disabled={props.disabled} name={props.name} defaultChecked={item.default} value={item.value} ref={(input) => { this._inputs[item.name]  = input }} onChange={this.onChange.bind(this,item,i)} /> {item.text}
                        </label>;

                    })}

                </div>;
                break;
            case 'vertical':
                content = <div>
                    {options.map((item,i) =>{

                        return (<div className="radio" key={i}>
                            <label>
                                <input type="radio" disabled={props.disabled} name={props.name} ref={(input) => { this._inputs[item.name]  = input }} defaultChecked={item.default} onChange={this.onChange.bind(this,item,i)} value={item.value} /> {item.text}
                            </label>
                        </div>);
                    })}
                </div>;
                break;
        }

        return (<div> <label>{props.title}</label>{content}</div>);
    }
}

export default RadioGroup;


// WEBPACK FOOTER //
// ./src/common/FormRenderer/Controls/RadioGroup.js